import './styles/vs.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../client/polyfills.js';

__webpack_public_path__ = `${window.UI_PATH}/`;

ReactDOM.render(<App />, document.getElementById('root'));
